<template>
    <div>
        <linkbutton toplabel="Add Guest" @click="startUpdateguest()" v-if="isNew"/>
        <pencilbutton @click="startUpdateguest()" v-if="!isNew" />
        <!-- MODAL -->
          <actionmodal ref="mymodal"> 
            <template v-slot:body>
                <form id="updateguestform" ref="updateguestform" @submit.prevent>
                    <label class="titlelabel">Update Guest</label>
                    <formentry :label="guestfirstNameLabel" isrequired='True' v-model="person.FirstName" />
                    <formentry :label="guestlastNameLabel" isrequired='True' v-model="person.LastName"  />
                   
                    <formentry label="Email" inputtype="email" isrequired='True' v-model="person.EmailAddress" @blur="updateEmail"/>
                    <formentry label="Phone" inputtype="tel" isrequired='False' @blur="leavePhone" v-model="person.PhoneNumber1"/> 
                    <formentry label="Student #" :isrequired="addGuestRequireStudentID" v-model="person.StudentID"/>
                   

                    <div class="vertFlex ">
                        <label for="" class="" v-if="showOptInEmail || showOptInSMS">Communications Agreement</label>
                        <label for="" class="" v-if="showOptInEmail || showOptInSMS">Guest agrees to receive communications through:</label>
                        <label for="" class="" v-if="showOptInEmail && showOptInSMS">(Check at least one)</label>
                    
                        <div class="horizFlex centered" v-if="showOptInEmail">
                            <input class="entryCheckbox" type="checkbox" v-model="person.optInForEmail" >
                            <label for="" :class="checkClass(person.optInForEmail)">Email</label>
                        </div>

                        <div class="horizFlex topMargin centered" v-if="showOptInSMS">
                            <input class="entryCheckbox" type="checkbox" v-model="person.optInForText" @change="setoptsms">
                            <label for="" :class="checkClass(person.optInForText)">Text Messaging</label>
                        </div>
                        <label v-if="showOptInSMS" for="" class="">({{personTypeText}} has given you consent to send text messages and understands that standard messaging and data rates may apply)</label>
                        
                    </div> 
                    <!-- <div class="entry" >
                        <div class="entryTextDiv">
                            <label class="entryLabel" for="">Location</label>
                        </div>
                        <div class="entryTextDiv">
                            <select name="" id="" class='entrySelect' required v-model="person.locationId_Primary"  >
                                <option v-for="loc in LocationList" :key="loc.id" :value="loc.id" >
                                    {{loc.name}}
                                </option>
                            </select>
                        </div>
                    </div> -->
                    <smallbutton  @click="saveUpdatedguest()" toplabel="Save" />
                    <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel"/>
                    <div>
                        <label class="responsemessage">{{responseMessage}}</label>
                    </div>
                </form>
                
            </template>
          </actionmodal>
        </div>
    </template>
    
    <script>
    import datamethods from '../../services/datamethods'
    import format from '../../style/format'
    import smallbutton from '../controls/button.vue'
    import actionmodal from '../controls/actionmodal.vue'
    import formentry from '../controls/entry.vue'
    import linkbutton from '../controls/linkbutton.vue'
    import pencilbutton from '../controls/pencilbutton.vue'
    import {mapFields} from 'vuex-map-fields'
    import pos from '../../services/pos.js'
    export default {
        name:'addguest',
        components:{
            smallbutton,
            actionmodal,
            formentry,
            linkbutton,
            pencilbutton
        },
        props:{
            guestId:{
                type:Number,
                required:true
            },
            isNew:{
                type:Boolean,
                default:false
            }
            
        },
        mixins:[datamethods,format,pos],
        computed:{
            ...mapFields([
                
                'pleaseWait'
            ]),
            mapEmailToLocation(){
                if(window.MAP_EMAIL_TO_LOCATION==undefined){return false}
                else{return window.MAP_EMAIL_TO_LOCATION}
            }
        },
        data(){
            return{
                responseMessage:'',
                paramTrue:true,
                paramFalse:false,

                person:{

                },
    
    
                guestfirstNameLabel:'Guest First Name',
                guestlastNameLabel:'Guest Last Name',
                guestPreferredLabel:'Preferred Name (Nickname)',
    
                //LocationList:[],
            }
        },
        
        methods:{
            async updateEmail(){
                if(this.person.EmailAddress==null){return}
                if(!this.mapEmailToLocation){return}

                console.log('map email to loc!!')
                //call api
                let req = {
                    ResponseString:this.person.EmailAddress
                }
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'mapemailtolocation')
                //handle response
            
                if(response.Successful){
                    this.person.locationId_Primary = response.ResponseInteger

                }else{
                    this.responseMessage = response.Message
                }
                this.pleaseWait=false;
            },
            async startUpdateguest(){
                //this.getLocations()
                this.newGuest()
                this.message = ''
    
                this.$refs.mymodal.openModal()
            },
            async getLocations(){
          
                //call api
               // this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(null,'locations')
                //handle response
            
                if(response.Successful){
                    this.pleaseWait=false;
                    this.LocationList= response.locationList
                    if(this.LocationList.length>0){
                    //console.log('loc ' + this.location.id)
                        
                    
                    //this.selectLocation()
                    }

                }else{
                    this.responseMessage = response.Message
                }
                this.pleaseWait=false;
            },
            async saveUpdatedguest(){
                if(this.$refs.updateguestform.checkValidity()==false){return}
    

                //default to optinforemail if we aren't showing
                if(!this.showOptInEmail){
                    this.person.optInForEmail=true
                }
                //if we show sms, and its checked, require phone
                if(this.showOptInSMS){
                    if(this.person.optInForText && (this.person.PhoneNumber1=='' || this.person.PhoneNumber1==null)){
                        this.responseMessage="Please enter a phone number for text updates"
                        return
                    } 
                }
                //if we show email, and its checked, require email
                if(this.showOptInEmail){
                    if(this.person.optInForEmail && (this.person.EmailAddress=='' || this.person.EmailAddress==null)){
                        this.responseMessage="Please enter an email address for email updates"
                        return
                    } 
                }
                //if we show both...one better be checked!!
                if(this.showOptInEmail && this.showOptInSMS && !this.person.optInForText && !this.person.optInForEmail){
                    this.responseMessage="Please select either text or email updates"
                    return
                }


                this.person.PhoneNumber1=this.$options.filters.cleanPhone(this.person.PhoneNumber1)
    
                let req = {
                    person:this.person,
                }
                var response = await this.callAPI(req,'updatepersonpos')
                if(response.Successful){
                    this.person = response.person
                    this.$refs.mymodal.closeModal()
    
                    var lookupstring =this.person.StudentID 
                    this.$emit('refresh',lookupstring)
              
                }else{
                    this.responseMessage = response.Message
                }
                this.pleaseWait=false;
            },
            newGuest(){
                this.person={
                    ID:-1,
                    FirstName:'',
                    LastName:'',
                    PhoneNumber1:'',
                    locationId_Primary:this.location.id,
                    StudentID:'',
                    IsActive:true,
                    EmailAddress:null,
                    optInForEmail:true,
                    optInForText:false
                }
            },
            leavePhone(){
    
                this.person.PhoneNumber1=this.$options.filters.formatPhone(this.person.PhoneNumber1);
                
                
            },
           checkClass(selected){
            if(selected){
                return "entryCheckLabelbold"
            }else{
                return "entryCheckLabel"
            }
        },
        }
    }
    </script>
    
    <style>
    .entryCheckLabel{
        margin:0px 0px 0px 5px;
        font-size:medium;
        text-align: left;  
        max-width: 420px;
    }
    .entryCheckLabelbold{
        margin:0px 0px 0px 5px;
        font-size:medium;
        text-align: left;  
        max-width: 420px;
        font-weight:bold;
    }
    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    